import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MatSnackBarRef,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MAT_SNACK_BAR_DATA
} from '@angular/material/snack-bar';
/**
 * PARAMETERS
 * @param message text to show.
 * @param type snackbar, warning, success, info.
 * @param action name of the button, default Undo or empty ''.
 * @param showCloseBtn show or not X button.
 * @param duration time duration to hide.
 */
export interface SnackbarData {
  message: string;
  type: string | string[];
  action: string;
  showCloseBtn: boolean;
  duration: number;
  horizontalPosition: MatSnackBarHorizontalPosition;
  verticalPosition: MatSnackBarVerticalPosition;
}

@Component({
  selector: 'vfs-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SnackbarComponent {
  constructor(
    private snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData
  ) {}

  action() {
    this.snackBarRef.dismissWithAction();
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
